import { Box, Typography, Collapse, Tooltip, IconButton } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { MappingAndRulesPanelProps } from './types';
import { useMappingAndRulesPanel } from './useMappingAndRulesPanel';
import { RuleBuilder } from '../RuleBuilder/RuleBuilder';
import './MappingAndRulesPanel.scss';

export const MappingAndRulesPanel = (props: MappingAndRulesPanelProps) => {
  const { handleHeaderClick } = useMappingAndRulesPanel(props);

  return (
    <Box className="mappingAndRulesPanel">
      {/* Header */}
      <Box className="header" onClick={handleHeaderClick}>
        <Tooltip title="Configure rules for instrument identification">
          <HelpOutlineIcon fontSize="small" sx={{ color: 'text.secondary' }} />
        </Tooltip>
        <Typography className="titleText">Rules</Typography>
        <IconButton
          size="small"
          className={`chevronIcon ${props.isExpanded ? 'expanded' : ''}`}
          onClick={e => {
            e.stopPropagation();
            handleHeaderClick();
          }}
        >
          <ExpandMoreIcon />
        </IconButton>
      </Box>

      {/* Content with RuleBuilder only */}
      <Collapse in={props.isExpanded}>
        <Box className="content">
          <RuleBuilder
            templateId={props.templateId}
            instrumentType={props.instrumentType}
            sectionId={props.sectionId}
            availableHeaders={props.availableHeaders}
          />
        </Box>
      </Collapse>
    </Box>
  );
};
